import { ENDPOINTS } from "../endpoint";
import axiosInstance from "../axiosInstance";


export const AdminAddProduct = async (data, token) => {
    const response = await axiosInstance.post(ENDPOINTS.ADDPRODUCT, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const AdminGetAllProduct = async (token) => {
    const response = await axiosInstance.get(ENDPOINTS.PRODUCTLIST, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}
export const DeleteProductAdmin = async (token, id) => {
    const response = await axiosInstance.delete(`${ENDPOINTS.DELETEPRODUCT}/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
    return response;
}
export const GetProductByIdAdmin = async (token, id) => {
    const response = await axiosInstance.get(`${ENDPOINTS.ProductByIdAdmin}/${id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );
    return response;
}

export const UpdateProductAdmin = async (token, id, productData) => {
    try {
        const response = await axiosInstance.put(`${ENDPOINTS.UpdateProductAdmin}/${id}`, productData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};

